import React, { useEffect, useState } from "react";
import {
  Button,
  Typography,
  Modal,
  Input,
  message,
  Select,
  Form,
  Image,
} from "antd";
import { authSVC, categorySVC } from "../../services";
import { Option } from "antd/es/mentions";
import { useB2BContext } from "../../context/ContextB2B";
import { useNavigate } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";

const { Text } = Typography;

function NewsFlash() {
  const [form] = Form.useForm();
  const [newsFlashData, setNewsFlashData] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [newsId, setNewsId] = useState<any>();

  const onFinish = (value: any) => {
    authSVC
      .AddNewsFlash({
        title: value.title,
        type: value.type,
        link: value.link,
      })
      .then((res: any) => {
        message.success("Added Successfully");
        form.resetFields();
        authSVC
          .getNewsFlash()
          .then((res: any) => {
            setNewsFlashData(res.data.data);
          })
          .catch((err: any) => {
            message.error(err.response?.data?.error);
          });
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  const onFinishEdit = (value: any) => {
    authSVC
      .UpdateNewsFlash(
        {
          title: value.title,
          type: value.type,
          link: value.link,
        },
        newsId
      )
      .then((res: any) => {
        message.success("Update Successfully");
        form.resetFields();
        setNewsId(false);
        authSVC
          .getNewsFlash()
          .then((res: any) => {
            setNewsFlashData(res.data.data);
            console.log(res.data.data, "HHHH");
          })
          .catch((err: any) => {
            message.error(err.response?.data?.error);
          });
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  useEffect(() => {
    authSVC
      .getNewsFlash()
      .then((res: any) => {
        setNewsFlashData(res.data.data);
        console.log(res.data.data, "HHHH");
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  }, []);

  const NewsEdit = (data: any) => {
    setIsEdit(true);
    setNewsId(data._id);
    form.setFieldsValue({
      title: data?.title,
      type: data?.type,
      link: data?.link,
    });
  };

  const NewsDelete = (data: any) => {
    authSVC
      .DeleteNewsFlash(data._id)
      .then((res: any) => {
        authSVC
          .getNewsFlash()
          .then((res: any) => {
            setNewsFlashData(res.data.data);
          })
          .catch((err: any) => {
            message.error(err.response?.data?.error);
          });
        message.success("Deleted Successfully");
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  return (
    <>
      <div className="add_form_wrapper">
        {isEdit ? (
          <>
            <h1>Edit News Flash</h1>
            <Form
              name="normal_login"
              initialValues={{ remember: true }}
              onFinish={onFinishEdit}
              form={form}
            >
              <Form.Item
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Title!",
                  },
                ]}
              >
                <TextArea
                  name="title"
                  className="input"
                  placeholder="Please Enter Title"
                  // maxLength={6}
                />
              </Form.Item>
              <Form.Item
                name="type"
                rules={[
                  {
                    required: true,
                    message: "Please select type!",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%", borderRadius: "24px" }}
                  placeholder="Select type"
                  optionFilterProp="children"
                >
                  <option value="link">Link</option>
                  <option value="video">Video</option>
                </Select>
              </Form.Item>
              <Form.Item
                name="link"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Link!",
                  },
                ]}
              >
                <TextArea
                  name="link"
                  className="input"
                  placeholder="Please Enter Link"
                  // maxLength={6}
                />
              </Form.Item>
              <Button
                className="button_add_emp"
                htmlType="submit"
                icon={<Image src="/img/new/add.svg" preview={false} alt="" />}
              >
                Update
              </Button>
            </Form>
          </>
        ) : (
          <>
            <h1>Add News Flash</h1>
            <Form
              name="normal_login"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              form={form}
            >
              <Form.Item
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Title!",
                  },
                ]}
              >
                <TextArea
                  name="title"
                  className="input"
                  placeholder="Please Enter Title"
                />
              </Form.Item>
              <Form.Item
                name={"type"}
                rules={[
                  {
                    required: true,
                    message: "Please select type!",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%", borderRadius: "24px" }}
                  placeholder="Select type"
                  optionFilterProp="children"
                >
                  <option value="link">Link</option>
                  <option value="video">Video</option>
                </Select>
              </Form.Item>
              <Form.Item
                name="link"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Link!",
                  },
                ]}
              >
                <TextArea
                  name="link"
                  className="input"
                  placeholder="Please Enter Link"
                />
              </Form.Item>
              <Button
                className="button_add_emp"
                htmlType="submit"
                icon={<Image src="/img/new/add.svg" preview={false} alt="" />}
              >
                Add
              </Button>
            </Form>
          </>
        )}
      </div>
      <div className="news_flash_wrapper">
        {newsFlashData &&
          newsFlashData?.map((data: any) => {
            return (
              <div className="news_flash_item">
                <div>
                  <h3>{data.title}</h3>
                  <p>
                    <strong>Type :</strong> {data.type}
                  </p>
                  <p>
                    <strong>Link : </strong>
                    {data.link}
                  </p>
                </div>
                <div className="button_set">
                  <button className="" onClick={() => NewsEdit(data)}>
                    Edit
                  </button>
                  <button className="red" onClick={() => NewsDelete(data)}>
                    Delete
                  </button>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}

export default NewsFlash;
